/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MatrixCareAdmissionDemographicsUpdateResponse } from './MatrixCareAdmissionDemographicsUpdateResponse';
import {
    MatrixCareAdmissionDemographicsUpdateResponseFromJSON,
    MatrixCareAdmissionDemographicsUpdateResponseFromJSONTyped,
    MatrixCareAdmissionDemographicsUpdateResponseToJSON,
    MatrixCareAdmissionDemographicsUpdateResponseToJSONTyped,
} from './MatrixCareAdmissionDemographicsUpdateResponse';

/**
 * 
 * @export
 * @interface UpdateMatrixCareHomeHealthAdmissionDemographics200Response
 */
export interface UpdateMatrixCareHomeHealthAdmissionDemographics200Response {
    /**
     * 
     * @type {MatrixCareAdmissionDemographicsUpdateResponse}
     * @memberof UpdateMatrixCareHomeHealthAdmissionDemographics200Response
     */
    data?: MatrixCareAdmissionDemographicsUpdateResponse;
}

/**
 * Check if a given object implements the UpdateMatrixCareHomeHealthAdmissionDemographics200Response interface.
 */
export function instanceOfUpdateMatrixCareHomeHealthAdmissionDemographics200Response(value: object): value is UpdateMatrixCareHomeHealthAdmissionDemographics200Response {
    return true;
}

export function UpdateMatrixCareHomeHealthAdmissionDemographics200ResponseFromJSON(json: any): UpdateMatrixCareHomeHealthAdmissionDemographics200Response {
    return UpdateMatrixCareHomeHealthAdmissionDemographics200ResponseFromJSONTyped(json, false);
}

export function UpdateMatrixCareHomeHealthAdmissionDemographics200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateMatrixCareHomeHealthAdmissionDemographics200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : MatrixCareAdmissionDemographicsUpdateResponseFromJSON(json['data']),
    };
}

export function UpdateMatrixCareHomeHealthAdmissionDemographics200ResponseToJSON(json: any): UpdateMatrixCareHomeHealthAdmissionDemographics200Response {
    return UpdateMatrixCareHomeHealthAdmissionDemographics200ResponseToJSONTyped(json, false);
}

export function UpdateMatrixCareHomeHealthAdmissionDemographics200ResponseToJSONTyped(value?: UpdateMatrixCareHomeHealthAdmissionDemographics200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': MatrixCareAdmissionDemographicsUpdateResponseToJSON(value['data']),
    };
}

